import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PATH_SEGMENTS, route } from '../config/paths';
import { listPublicDemos, DemoCatalogEntry } from '../services/publicDemosClient';
import LiveDemoShell from '../components/landing/LiveDemoShell';
import '../styles/screens/LiveDemo.css';

const LiveDemoGallery: React.FC = () => {
  const [demos, setDemos] = useState<DemoCatalogEntry[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const rows = await listPublicDemos();
        if (!cancelled) {
          setDemos(
            rows.slice().sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
          );
        }
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Failed to load demos');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <LiveDemoShell>
      <div className="live-demo live-demo-gallery">
        <div className="live-demo-header">
          <p className="live-demo-kicker">Voice Agent</p>
          <h1>Live AI demos</h1>
          <p>Pick a workflow and talk to the agent. No signup required.</p>
        </div>
        {loading && <div className="live-demo-muted">Loading demos…</div>}
        {error && <div className="live-demo-error">{error}</div>}
        <div className="live-demo-grid">
          {demos.map((demo) => (
            <Link
              key={demo.id}
              className="live-demo-card"
              to={route(PATH_SEGMENTS.LIVE_DEMO, demo.id)}
            >
              <div className="live-demo-card-top">
                <span className="live-demo-card-industry">{demo.industry}</span>
                {demo.featured ? <span className="live-demo-card-badge">Featured</span> : null}
              </div>
              <div className="live-demo-card-kicker">
                {demo.agent?.display_name || 'Agent'}
                {demo.languages?.length ? ` · ${demo.languages.join(', ')}` : ''}
              </div>
              <h2 className="live-demo-card-title">{demo.title}</h2>
              <p className="live-demo-card-summary">{demo.summary}</p>
              <ul className="live-demo-card-steps">
                {demo.steps.slice(0, 3).map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ul>
              <span className="live-demo-card-cta">
                Talk to {demo.agent?.display_name || 'the agent'} →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </LiveDemoShell>
  );
};

export default LiveDemoGallery;
